import { Bar } from 'vue-chartjs'
import 'chartjs-plugin-datalabels'

export default {
  extends: Bar,
  props: {
    options: {
      type: Object,
      required: true
    },
    chartData: {
      type: Object
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    options: {
      handler: function (options) {
        this.renderChart(this.chartData, options)
      },
      deep: true
    },
    chartData: {
      handler: function (chartData) {
        this.renderChart(chartData, this.options)
      }
    }
  }
}
